import RpcClass from "../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.TrancheBookingDetails';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class TrancheBookingDetails extends RpcClass{

    /**
     *  @class TrancheBookingDetails
     *  @alias module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails
     *  
     * */
    constructor(){
        super();

        /** @type {string}  */
        this.EID = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}  */
        this.attachments = null;
        /** @type {string}  */
        this.containerNumber = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {string}  */
        this.id = null;
        /** @type {string}  */
        this.orderDetailsId = null;
        /** @type {number}  */
        this.quantitySKU = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {string}  */
        this.trancheBookingId = null;
        /** @type {string}  */
        this.trancheId = null;
        /** @type {number}  */
        this.version = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }





    /** @type {LocalDate}  */
    get trancheBookingIdATA(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdATA'] : null, this.__metadata__['trancheBookingIdATA']?.remoteType);
    }
    set trancheBookingIdATA(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get trancheBookingIdATD(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdATD'] : null, this.__metadata__['trancheBookingIdATD']?.remoteType);
    }
    set trancheBookingIdATD(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdBLNumber(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdBLNumber'] : null, this.__metadata__['trancheBookingIdBLNumber']?.remoteType);
    }
    set trancheBookingIdBLNumber(val){
    }
    // fk: false

    /** @type {BigDecimal}  */
    get trancheBookingIdCBM(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdCBM'] : null, this.__metadata__['trancheBookingIdCBM']?.remoteType);
    }
    set trancheBookingIdCBM(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get trancheBookingIdETA(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdETA'] : null, this.__metadata__['trancheBookingIdETA']?.remoteType);
    }
    set trancheBookingIdETA(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get trancheBookingIdETD(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdETD'] : null, this.__metadata__['trancheBookingIdETD']?.remoteType);
    }
    set trancheBookingIdETD(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get trancheBookingIdTrancheIdOrderIdEXWPI(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdOrderIdEXWPI'] : null, this.__metadata__['trancheBookingIdTrancheIdOrderIdEXWPI']?.remoteType);
    }
    set trancheBookingIdTrancheIdOrderIdEXWPI(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdTrancheIdOrderIdSupplierIdAddressLine1(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdOrderIdSupplierIdAddressLine1'] : null, this.__metadata__['trancheBookingIdTrancheIdOrderIdSupplierIdAddressLine1']?.remoteType);
    }
    set trancheBookingIdTrancheIdOrderIdSupplierIdAddressLine1(val){
    }
    // fk: false

    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get trancheBookingIdAllInCost(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdAllInCost'] : null, this.__metadata__['trancheBookingIdAllInCost']?.remoteType);
    }
    set trancheBookingIdAllInCost(val){
    }
    // fk: false

    /** @type {boolean}  */
    get trancheBookingIdAllInCostAccept(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdAllInCostAccept'] : null, this.__metadata__['trancheBookingIdAllInCostAccept']?.remoteType);
    }
    set trancheBookingIdAllInCostAccept(val){
    }
    // fk: false

    /** @type {number}  */
    get trancheBookingIdCartons(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdCartons'] : null, this.__metadata__['trancheBookingIdCartons']?.remoteType);
    }
    set trancheBookingIdCartons(val){
    }
    // fk: false

    /** @type {string}  */
    get orderDetailsIdCategory(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderDetailsIdCategory'] : null, this.__metadata__['orderDetailsIdCategory']?.remoteType);
    }
    set orderDetailsIdCategory(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getOrderDetailsIdCategoryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Category', 'orderDetailsIdCategory',  allowRemote); //  false 
    }

    /** @returns {String} */
    getOrderDetailsIdCategoryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Category', 'orderDetailsIdCategory'); //  false 
    }

    /** @returns {Promise<Category>} */
    getOrderDetailsIdCategoryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Category', 'orderDetailsIdCategory',  allowRemote); //  false 
    }

    /** @type {LocalDate}  */
    get trancheBookingIdConfirmationSADDraft(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdConfirmationSADDraft'] : null, this.__metadata__['trancheBookingIdConfirmationSADDraft']?.remoteType);
    }
    set trancheBookingIdConfirmationSADDraft(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdContainerType(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdContainerType'] : null, this.__metadata__['trancheBookingIdContainerType']?.remoteType);
    }
    set trancheBookingIdContainerType(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdContainerTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ContainerType', 'trancheBookingIdContainerType',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdContainerTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ContainerType', 'trancheBookingIdContainerType'); //  false 
    }

    /** @returns {Promise<ContainerType>} */
    getTrancheBookingIdContainerTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ContainerType', 'trancheBookingIdContainerType',  allowRemote); //  false 
    }

    /** @type {string}  */
    get orderDetailsIdCountry(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderDetailsIdCountry'] : null, this.__metadata__['orderDetailsIdCountry']?.remoteType);
    }
    set orderDetailsIdCountry(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getOrderDetailsIdCountryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Country', 'orderDetailsIdCountry',  allowRemote); //  false 
    }

    /** @returns {String} */
    getOrderDetailsIdCountryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Country', 'orderDetailsIdCountry'); //  false 
    }

    /** @returns {Promise<Country>} */
    getOrderDetailsIdCountryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Country', 'orderDetailsIdCountry',  allowRemote); //  false 
    }

    /** @type {LocalDate}  */
    get trancheBookingIdDateDPP(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdDateDPP'] : null, this.__metadata__['trancheBookingIdDateDPP']?.remoteType);
    }
    set trancheBookingIdDateDPP(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get trancheBookingIdDeliveryDate(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdDeliveryDate'] : null, this.__metadata__['trancheBookingIdDeliveryDate']?.remoteType);
    }
    set trancheBookingIdDeliveryDate(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdDeliveryPort(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdDeliveryPort'] : null, this.__metadata__['trancheBookingIdDeliveryPort']?.remoteType);
    }
    set trancheBookingIdDeliveryPort(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdDeliveryPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'trancheBookingIdDeliveryPort',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdDeliveryPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'trancheBookingIdDeliveryPort'); //  false 
    }

    /** @returns {Promise<DeliveryPort>} */
    getTrancheBookingIdDeliveryPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.DeliveryPort', 'trancheBookingIdDeliveryPort',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheBookingIdTrancheIdDeliveryType(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdDeliveryType'] : null, this.__metadata__['trancheBookingIdTrancheIdDeliveryType']?.remoteType);
    }
    set trancheBookingIdTrancheIdDeliveryType(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdTrancheIdDeliveryTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.DeliveryType', 'trancheBookingIdTrancheIdDeliveryType',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdTrancheIdDeliveryTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.DeliveryType', 'trancheBookingIdTrancheIdDeliveryType'); //  false 
    }

    /** @returns {Promise<DeliveryType>} */
    getTrancheBookingIdTrancheIdDeliveryTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.DeliveryType', 'trancheBookingIdTrancheIdDeliveryType',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheBookingIdTrancheIdDescriptionDPP(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdDescriptionDPP'] : null, this.__metadata__['trancheBookingIdTrancheIdDescriptionDPP']?.remoteType);
    }
    set trancheBookingIdTrancheIdDescriptionDPP(val){
    }
    // fk: false

    /** @type {boolean}  */
    get trancheBookingIdDescriptionDPPAccept(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdDescriptionDPPAccept'] : null, this.__metadata__['trancheBookingIdDescriptionDPPAccept']?.remoteType);
    }
    set trancheBookingIdDescriptionDPPAccept(val){
    }
    // fk: false

    /** @type {boolean}  */
    get trancheBookingIdTrancheIdDocuments(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdDocuments'] : null, this.__metadata__['trancheBookingIdTrancheIdDocuments']?.remoteType);
    }
    set trancheBookingIdTrancheIdDocuments(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdForwarding(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdForwarding'] : null, this.__metadata__['trancheBookingIdForwarding']?.remoteType);
    }
    set trancheBookingIdForwarding(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdForwardingLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Forwarding', 'trancheBookingIdForwarding',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdForwardingStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Forwarding', 'trancheBookingIdForwarding'); //  false 
    }

    /** @returns {Promise<Forwarding>} */
    getTrancheBookingIdForwardingEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Forwarding', 'trancheBookingIdForwarding',  allowRemote); //  false 
    }

    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get trancheBookingIdFreightCost(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdFreightCost'] : null, this.__metadata__['trancheBookingIdFreightCost']?.remoteType);
    }
    set trancheBookingIdFreightCost(val){
    }
    // fk: false

    /** @type {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}  */
    get orderDetailsIdProductIdGallery(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderDetailsIdProductIdGallery'] : null, this.__metadata__['orderDetailsIdProductIdGallery']?.remoteType);
    }
    set orderDetailsIdProductIdGallery(val){
    }
    // fk: false

    /** @type {string}  */
    get orderDetailsIdInspection(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderDetailsIdInspection'] : null, this.__metadata__['orderDetailsIdInspection']?.remoteType);
    }
    set orderDetailsIdInspection(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getOrderDetailsIdInspectionLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Inspection', 'orderDetailsIdInspection',  allowRemote); //  false 
    }

    /** @returns {String} */
    getOrderDetailsIdInspectionStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Inspection', 'orderDetailsIdInspection'); //  false 
    }

    /** @returns {Promise<Inspection>} */
    getOrderDetailsIdInspectionEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Inspection', 'orderDetailsIdInspection',  allowRemote); //  false 
    }

    /** @type {boolean}  */
    get trancheIdInspection(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdInspection'] : null, this.__metadata__['trancheIdInspection']?.remoteType);
    }
    set trancheIdInspection(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdTrancheIdOrderIdMerchant(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdOrderIdMerchant'] : null, this.__metadata__['trancheBookingIdTrancheIdOrderIdMerchant']?.remoteType);
    }
    set trancheBookingIdTrancheIdOrderIdMerchant(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdTrancheIdOrderIdMerchantLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'trancheBookingIdTrancheIdOrderIdMerchant',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdTrancheIdOrderIdMerchantStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'trancheBookingIdTrancheIdOrderIdMerchant'); //  false 
    }

    /** @returns {Promise<ApplicationUser>} */
    getTrancheBookingIdTrancheIdOrderIdMerchantEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'trancheBookingIdTrancheIdOrderIdMerchant',  allowRemote); //  false 
    }

    /** @type {string}  */
    get orderDetailsIdProductIdName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderDetailsIdProductIdName'] : null, this.__metadata__['orderDetailsIdProductIdName']?.remoteType);
    }
    set orderDetailsIdProductIdName(val){
    }
    // fk: false

    /** @type {boolean}  */
    get trancheBookingIdTrancheIdNoAdditionalCosts(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdNoAdditionalCosts'] : null, this.__metadata__['trancheBookingIdTrancheIdNoAdditionalCosts']?.remoteType);
    }
    set trancheBookingIdTrancheIdNoAdditionalCosts(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdNotes(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdNotes'] : null, this.__metadata__['trancheBookingIdNotes']?.remoteType);
    }
    set trancheBookingIdNotes(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdNumberInvoice(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdNumberInvoice'] : null, this.__metadata__['trancheBookingIdNumberInvoice']?.remoteType);
    }
    set trancheBookingIdNumberInvoice(val){
    }
    // fk: false

    /** @type {number}  */
    get orderDetailsIdProductIdNumberOfProduct(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderDetailsIdProductIdNumberOfProduct'] : null, this.__metadata__['orderDetailsIdProductIdNumberOfProduct']?.remoteType);
    }
    set orderDetailsIdProductIdNumberOfProduct(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdTrancheIdOrderIdNumberOfProforma(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdOrderIdNumberOfProforma'] : null, this.__metadata__['trancheBookingIdTrancheIdOrderIdNumberOfProforma']?.remoteType);
    }
    set trancheBookingIdTrancheIdOrderIdNumberOfProforma(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdTrancheIdNumberOfTranche(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdNumberOfTranche'] : null, this.__metadata__['trancheBookingIdTrancheIdNumberOfTranche']?.remoteType);
    }
    set trancheBookingIdTrancheIdNumberOfTranche(val){
    }
    // fk: false

    /** @type {number}  */
    get orderDetailsIdOrderedQuantity(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderDetailsIdOrderedQuantity'] : null, this.__metadata__['orderDetailsIdOrderedQuantity']?.remoteType);
    }
    set orderDetailsIdOrderedQuantity(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdPlaceOfDelivery(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdPlaceOfDelivery'] : null, this.__metadata__['trancheBookingIdPlaceOfDelivery']?.remoteType);
    }
    set trancheBookingIdPlaceOfDelivery(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdPlaceOfDeliveryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.PlaceOfDelivery', 'trancheBookingIdPlaceOfDelivery',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdPlaceOfDeliveryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.PlaceOfDelivery', 'trancheBookingIdPlaceOfDelivery'); //  false 
    }

    /** @returns {Promise<PlaceOfDelivery>} */
    getTrancheBookingIdPlaceOfDeliveryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.PlaceOfDelivery', 'trancheBookingIdPlaceOfDelivery',  allowRemote); //  false 
    }

    /** @type {string}  */
    get orderDetailsIdPort(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderDetailsIdPort'] : null, this.__metadata__['orderDetailsIdPort']?.remoteType);
    }
    set orderDetailsIdPort(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getOrderDetailsIdPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Port', 'orderDetailsIdPort',  allowRemote); //  false 
    }

    /** @returns {String} */
    getOrderDetailsIdPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Port', 'orderDetailsIdPort'); //  false 
    }

    /** @returns {Promise<Port>} */
    getOrderDetailsIdPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Port', 'orderDetailsIdPort',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheBookingIdPort(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdPort'] : null, this.__metadata__['trancheBookingIdPort']?.remoteType);
    }
    set trancheBookingIdPort(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Port', 'trancheBookingIdPort',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Port', 'trancheBookingIdPort'); //  false 
    }

    /** @returns {Promise<Port>} */
    getTrancheBookingIdPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Port', 'trancheBookingIdPort',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheBookingIdTrancheIdOrderIdSupplierIdPrimaryEmail(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdOrderIdSupplierIdPrimaryEmail'] : null, this.__metadata__['trancheBookingIdTrancheIdOrderIdSupplierIdPrimaryEmail']?.remoteType);
    }
    set trancheBookingIdTrancheIdOrderIdSupplierIdPrimaryEmail(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdTrancheIdOrderIdSupplierIdPrimaryPhone(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdOrderIdSupplierIdPrimaryPhone'] : null, this.__metadata__['trancheBookingIdTrancheIdOrderIdSupplierIdPrimaryPhone']?.remoteType);
    }
    set trancheBookingIdTrancheIdOrderIdSupplierIdPrimaryPhone(val){
    }
    // fk: false

    /** @type {number}  */
    get trancheBookingIdQuantity(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdQuantity'] : null, this.__metadata__['trancheBookingIdQuantity']?.remoteType);
    }
    set trancheBookingIdQuantity(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get trancheBookingIdTrancheIdRealEXW(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdRealEXW'] : null, this.__metadata__['trancheBookingIdTrancheIdRealEXW']?.remoteType);
    }
    set trancheBookingIdTrancheIdRealEXW(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdReleased(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdReleased'] : null, this.__metadata__['trancheBookingIdReleased']?.remoteType);
    }
    set trancheBookingIdReleased(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdReleasedLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Released', 'trancheBookingIdReleased',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdReleasedStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Released', 'trancheBookingIdReleased'); //  false 
    }

    /** @returns {Promise<Released>} */
    getTrancheBookingIdReleasedEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Released', 'trancheBookingIdReleased',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheBookingIdTrancheIdOrderIdSeasonId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdOrderIdSeasonId'] : null, this.__metadata__['trancheBookingIdTrancheIdOrderIdSeasonId']?.remoteType);
    }
    set trancheBookingIdTrancheIdOrderIdSeasonId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdTrancheIdOrderIdSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Season', 'trancheBookingIdTrancheIdOrderIdSeasonId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdTrancheIdOrderIdSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Season', 'trancheBookingIdTrancheIdOrderIdSeasonId'); //  false 
    }

    /** @returns {Promise<Season>} */
    getTrancheBookingIdTrancheIdOrderIdSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Season', 'trancheBookingIdTrancheIdOrderIdSeasonId',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheBookingIdShipowner(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdShipowner'] : null, this.__metadata__['trancheBookingIdShipowner']?.remoteType);
    }
    set trancheBookingIdShipowner(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdShipownerLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Shipowner', 'trancheBookingIdShipowner',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdShipownerStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Shipowner', 'trancheBookingIdShipowner'); //  false 
    }

    /** @returns {Promise<Shipowner>} */
    getTrancheBookingIdShipownerEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Shipowner', 'trancheBookingIdShipowner',  allowRemote); //  false 
    }

    /** @type {LocalDate}  */
    get trancheBookingIdShippingOrderDate(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdShippingOrderDate'] : null, this.__metadata__['trancheBookingIdShippingOrderDate']?.remoteType);
    }
    set trancheBookingIdShippingOrderDate(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get trancheBookingIdShippingToForwarding(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdShippingToForwarding'] : null, this.__metadata__['trancheBookingIdShippingToForwarding']?.remoteType);
    }
    set trancheBookingIdShippingToForwarding(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdStatus'] : null, this.__metadata__['trancheBookingIdStatus']?.remoteType);
    }
    set trancheBookingIdStatus(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.LogisticStatus', 'trancheBookingIdStatus',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.LogisticStatus', 'trancheBookingIdStatus'); //  false 
    }

    /** @returns {Promise<LogisticStatus>} */
    getTrancheBookingIdStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.LogisticStatus', 'trancheBookingIdStatus',  allowRemote); //  false 
    }

    /** @type {number}  */
    get trancheBookingIdStorage(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdStorage'] : null, this.__metadata__['trancheBookingIdStorage']?.remoteType);
    }
    set trancheBookingIdStorage(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdTrancheIdOrderIdSupplierId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdOrderIdSupplierId'] : null, this.__metadata__['trancheBookingIdTrancheIdOrderIdSupplierId']?.remoteType);
    }
    set trancheBookingIdTrancheIdOrderIdSupplierId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdTrancheIdOrderIdSupplierIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'trancheBookingIdTrancheIdOrderIdSupplierId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdTrancheIdOrderIdSupplierIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'trancheBookingIdTrancheIdOrderIdSupplierId'); //  false 
    }

    /** @returns {Promise<Suppliers>} */
    getTrancheBookingIdTrancheIdOrderIdSupplierIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'trancheBookingIdTrancheIdOrderIdSupplierId',  allowRemote); //  false 
    }

    /** @type {string}  */
    get orderDetailsIdProductIdSupplierProductId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderDetailsIdProductIdSupplierProductId'] : null, this.__metadata__['orderDetailsIdProductIdSupplierProductId']?.remoteType);
    }
    set orderDetailsIdProductIdSupplierProductId(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get trancheBookingIdTransmissionOriginals(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTransmissionOriginals'] : null, this.__metadata__['trancheBookingIdTransmissionOriginals']?.remoteType);
    }
    set trancheBookingIdTransmissionOriginals(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheBookingIdTransportType(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTransportType'] : null, this.__metadata__['trancheBookingIdTransportType']?.remoteType);
    }
    set trancheBookingIdTransportType(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdTransportTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'trancheBookingIdTransportType',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdTransportTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'trancheBookingIdTransportType'); //  false 
    }

    /** @returns {Promise<TransportType>} */
    getTrancheBookingIdTransportTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'trancheBookingIdTransportType',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheBookingIdTrancheIdTransportType(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdTransportType'] : null, this.__metadata__['trancheBookingIdTrancheIdTransportType']?.remoteType);
    }
    set trancheBookingIdTrancheIdTransportType(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdTrancheIdTransportTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'trancheBookingIdTrancheIdTransportType',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdTrancheIdTransportTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'trancheBookingIdTrancheIdTransportType'); //  false 
    }

    /** @returns {Promise<TransportType>} */
    getTrancheBookingIdTrancheIdTransportTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'trancheBookingIdTrancheIdTransportType',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheBookingIdTrancheIdTypeOfDocument(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdTypeOfDocument'] : null, this.__metadata__['trancheBookingIdTrancheIdTypeOfDocument']?.remoteType);
    }
    set trancheBookingIdTrancheIdTypeOfDocument(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdTrancheIdTypeOfDocumentLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TypeOfDocument', 'trancheBookingIdTrancheIdTypeOfDocument',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdTrancheIdTypeOfDocumentStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TypeOfDocument', 'trancheBookingIdTrancheIdTypeOfDocument'); //  false 
    }

    /** @returns {Promise<TypeOfDocument>} */
    getTrancheBookingIdTrancheIdTypeOfDocumentEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TypeOfDocument', 'trancheBookingIdTrancheIdTypeOfDocument',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheBookingIdTrancheIdWarehouse(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheBookingIdTrancheIdWarehouse'] : null, this.__metadata__['trancheBookingIdTrancheIdWarehouse']?.remoteType);
    }
    set trancheBookingIdTrancheIdWarehouse(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheBookingIdTrancheIdWarehouseLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Warehouse', 'trancheBookingIdTrancheIdWarehouse',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheBookingIdTrancheIdWarehouseStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Warehouse', 'trancheBookingIdTrancheIdWarehouse'); //  false 
    }

    /** @returns {Promise<Warehouse>} */
    getTrancheBookingIdTrancheIdWarehouseEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Warehouse', 'trancheBookingIdTrancheIdWarehouse',  allowRemote); //  false 
    }

    /** @type {boolean}  */
    get bookingPMApproval(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['bookingPMApproval'] : null, this.__metadata__['bookingPMApproval']?.remoteType);
    }
    set bookingPMApproval(val){
    }


    /** @type {BigDecimal}  */
    get cBMPlan(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['cBMPlan'] : null, this.__metadata__['cBMPlan']?.remoteType);
    }
    set cBMPlan(val){
    }


    /** @type {BigDecimal}  */
    get cartonsPlan(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['cartonsPlan'] : null, this.__metadata__['cartonsPlan']?.remoteType);
    }
    set cartonsPlan(val){
    }


    /** @type {string}  */
    get defaultEAN(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['defaultEAN'] : null, this.__metadata__['defaultEAN']?.remoteType);
    }
    set defaultEAN(val){
    }


    /** @type {number}  */
    get deliveryWeek(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['deliveryWeek'] : null, this.__metadata__['deliveryWeek']?.remoteType);
    }
    set deliveryWeek(val){
    }


    /** @type {LocalDate}  */
    get plannedDateOfInspection(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['plannedDateOfInspection'] : null, this.__metadata__['plannedDateOfInspection']?.remoteType);
    }
    set plannedDateOfInspection(val){
    }


    /** @type {string}  */
    get productCategory(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productCategory'] : null, this.__metadata__['productCategory']?.remoteType);
    }
    set productCategory(val){
    }


    /** @type {string}  */
    get productFullName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productFullName'] : null, this.__metadata__['productFullName']?.remoteType);
    }
    set productFullName(val){
    }


    /** @type {boolean}  */
    get qCPMApproval(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['qCPMApproval'] : null, this.__metadata__['qCPMApproval']?.remoteType);
    }
    set qCPMApproval(val){
    }


    /** @type {string}  */
    get relatedOrderNumber(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['relatedOrderNumber'] : null, this.__metadata__['relatedOrderNumber']?.remoteType);
    }
    set relatedOrderNumber(val){
    }


    /** @type {boolean}  */
    get sanepid(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['sanepid'] : null, this.__metadata__['sanepid']?.remoteType);
    }
    set sanepid(val){
    }


    /** @type {number}  */
    get stockForDelivery(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['stockForDelivery'] : null, this.__metadata__['stockForDelivery']?.remoteType);
    }
    set stockForDelivery(val){
    }


    /** @type {LocalDate}  */
    get takeTo(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['takeTo'] : null, this.__metadata__['takeTo']?.remoteType);
    }
    set takeTo(val){
    }


    /** @type {number}  */
    get wMS(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['wMS'] : null, this.__metadata__['wMS']?.remoteType);
    }
    set wMS(val){
    }


    /** @type {LocalDate}  */
    get wMSEstimation(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['wMSEstimation'] : null, this.__metadata__['wMSEstimation']?.remoteType);
    }
    set wMSEstimation(val){
    }


    /** @type {number}  */
    get weekReadyToExecute(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['weekReadyToExecute'] : null, this.__metadata__['weekReadyToExecute']?.remoteType);
    }
    set weekReadyToExecute(val){
    }


    /** @type {number}  */
    get weekRelativeToStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['weekRelativeToStatus'] : null, this.__metadata__['weekRelativeToStatus']?.remoteType);
    }
    set weekRelativeToStatus(val){
    }


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    withAttachments(val){
        this.attachments = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    withContainerNumber(val){
        this.containerNumber = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    withOrderDetailsId(val){
        this.orderDetailsId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getOrderDetailsIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.OrderDetails', 'orderDetailsId', allowRemote); //  true 
    }

    /** @returns {String} */
        getOrderDetailsIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.OrderDetails', 'orderDetailsId'); //  true 
    }

        /** @returns {Promise<OrderDetails>} */
    getOrderDetailsIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.OrderDetails', 'orderDetailsId', allowRemote); //  true 
    }

    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    withQuantitySKU(val){
        this.quantitySKU = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    withTrancheBookingId(val){
        this.trancheBookingId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTrancheBookingIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.TrancheBooking', 'trancheBookingId', allowRemote); //  true 
    }

    /** @returns {String} */
        getTrancheBookingIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.TrancheBooking', 'trancheBookingId'); //  true 
    }

        /** @returns {Promise<TrancheBooking>} */
    getTrancheBookingIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.TrancheBooking', 'trancheBookingId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    withTrancheId(val){
        this.trancheId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTrancheIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Tranche', 'trancheId', allowRemote); //  true 
    }

    /** @returns {String} */
        getTrancheIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Tranche', 'trancheId'); //  true 
    }

        /** @returns {Promise<Tranche>} */
    getTrancheIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Tranche', 'trancheId', allowRemote); //  true 
    }

    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBookingDetails.TrancheBookingDetails}
     */
    withVersion(val){
        this.version = val;
        return this;
    };




    /**
    * @param {string[]?} fields
    * @returns {Promise<TrancheBookingDetails>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadTrancheBookingDetails(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'orderDetailsIdCategory'){
            return this.getOrderDetailsIdCategoryLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdContainerType'){
            return this.getTrancheBookingIdContainerTypeLabel(allowRemote);
        }
        if(fiendName === 'orderDetailsIdCountry'){
            return this.getOrderDetailsIdCountryLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdDeliveryPort'){
            return this.getTrancheBookingIdDeliveryPortLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdTrancheIdDeliveryType'){
            return this.getTrancheBookingIdTrancheIdDeliveryTypeLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdForwarding'){
            return this.getTrancheBookingIdForwardingLabel(allowRemote);
        }
        if(fiendName === 'orderDetailsIdInspection'){
            return this.getOrderDetailsIdInspectionLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdTrancheIdOrderIdMerchant'){
            return this.getTrancheBookingIdTrancheIdOrderIdMerchantLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdPlaceOfDelivery'){
            return this.getTrancheBookingIdPlaceOfDeliveryLabel(allowRemote);
        }
        if(fiendName === 'orderDetailsIdPort'){
            return this.getOrderDetailsIdPortLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdPort'){
            return this.getTrancheBookingIdPortLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdReleased'){
            return this.getTrancheBookingIdReleasedLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdTrancheIdOrderIdSeasonId'){
            return this.getTrancheBookingIdTrancheIdOrderIdSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdShipowner'){
            return this.getTrancheBookingIdShipownerLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdStatus'){
            return this.getTrancheBookingIdStatusLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdTrancheIdOrderIdSupplierId'){
            return this.getTrancheBookingIdTrancheIdOrderIdSupplierIdLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdTransportType'){
            return this.getTrancheBookingIdTransportTypeLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdTrancheIdTransportType'){
            return this.getTrancheBookingIdTrancheIdTransportTypeLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdTrancheIdTypeOfDocument'){
            return this.getTrancheBookingIdTrancheIdTypeOfDocumentLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingIdTrancheIdWarehouse'){
            return this.getTrancheBookingIdTrancheIdWarehouseLabel(allowRemote);
        }
        if(fiendName === 'orderDetailsId'){
            return this.getOrderDetailsIdLabel(allowRemote);
        }
        if(fiendName === 'trancheBookingId'){
            return this.getTrancheBookingIdLabel(allowRemote);
        }
        if(fiendName === 'trancheId'){
            return this.getTrancheIdLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'orderDetailsId'){
            return this.getOrderDetailsIdEntity(allowRemote);
        }
        if(fiendName === 'trancheBookingId'){
            return this.getTrancheBookingIdEntity(allowRemote);
        }
        if(fiendName === 'trancheId'){
            return this.getTrancheIdEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<TrancheBookingDetails>}
 */
async function loadTrancheBookingDetails(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<TrancheBookingDetails[]>}
 */
async function listTrancheBookingDetails(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelTrancheBookingDetails(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<TrancheBookingDetails>}
 */
TrancheBookingDetails.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<TrancheBookingDetails[]>}
 */
TrancheBookingDetails.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<TrancheBookingDetails[]>}
 */
TrancheBookingDetails.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<TrancheBookingDetails[]>}
 */
TrancheBookingDetails.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<TrancheBookingDetails>}
 */
TrancheBookingDetails.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return TrancheBookingDetails.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
TrancheBookingDetails.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
TrancheBookingDetails.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
TrancheBookingDetails.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
TrancheBookingDetails.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
TrancheBookingDetails.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['attachments'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'mapped' : 'false'};
metadata['containerNumber'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderDetailsId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['quantitySKU'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['trancheBookingId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['bookingPMApproval'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['cBMPlan'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['cartonsPlan'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['defaultEAN'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['deliveryWeek'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['plannedDateOfInspection'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['productCategory'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productFullName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['qCPMApproval'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['relatedOrderNumber'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['sanepid'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['stockForDelivery'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['takeTo'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['wMS'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['wMSEstimation'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['weekReadyToExecute'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['weekRelativeToStatus'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['trancheBookingIdATA'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdATD'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdBLNumber'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdCBM'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['trancheBookingIdETA'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdETD'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdTrancheIdOrderIdEXWPI'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdTrancheIdOrderIdSupplierIdAddressLine1'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdAllInCost'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['trancheBookingIdAllInCostAccept'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['trancheBookingIdCartons'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['orderDetailsIdCategory'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdConfirmationSADDraft'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdContainerType'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderDetailsIdCountry'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdDateDPP'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdDeliveryDate'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdDeliveryPort'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdDeliveryType'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdDescriptionDPP'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdDescriptionDPPAccept'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdDocuments'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['trancheBookingIdForwarding'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdFreightCost'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['orderDetailsIdProductIdGallery'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'jsType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'mapped' : 'false'};
metadata['orderDetailsIdInspection'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdInspection'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdOrderIdMerchant'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderDetailsIdProductIdName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdNoAdditionalCosts'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['trancheBookingIdNotes'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdNumberInvoice'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderDetailsIdProductIdNumberOfProduct'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdOrderIdNumberOfProforma'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdNumberOfTranche'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderDetailsIdOrderedQuantity'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['trancheBookingIdPlaceOfDelivery'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderDetailsIdPort'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdPort'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdOrderIdSupplierIdPrimaryEmail'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdOrderIdSupplierIdPrimaryPhone'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdQuantity'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdRealEXW'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdReleased'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdOrderIdSeasonId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdShipowner'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdShippingOrderDate'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdShippingToForwarding'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdStatus'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdStorage'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdOrderIdSupplierId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderDetailsIdProductIdSupplierProductId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdTransmissionOriginals'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheBookingIdTransportType'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdTransportType'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdTypeOfDocument'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheBookingIdTrancheIdWarehouse'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.TrancheBookingDetails';
metadata.__type_short__ = 'TrancheBookingDetails';
TrancheBookingDetails.prototype.__metadata__ = metadata;

TrancheBookingDetails.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/TrancheBookingDetails */
export default TrancheBookingDetails

export { TrancheBookingDetails , loadTrancheBookingDetails, listTrancheBookingDetails, labelTrancheBookingDetails }
